var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { Typography, RadioGroup, FormGroup, FormControlLabel, Radio, Card, Grid, CardContent, FormControl, } from '@mui/material';
import { useTranslation } from 'react-i18next';
var CardWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 5px 0px;\n"], ["\n  margin: 5px 0px;\n"])));
var summaryColumns = [
    'swiftCode',
    'beneficiaryBankName',
    'accountNumber',
];
var SelectBankAccountList = function (_a) {
    var selectedBankAccountId = _a.selectedBankAccountId, bankAccounts = _a.bankAccounts, onChange = _a.onChange;
    var t = useTranslation().t;
    return (React.createElement(FormGroup, null,
        React.createElement(FormControl, null,
            React.createElement(RadioGroup, { value: selectedBankAccountId || '', onChange: function (e) { return onChange(e.target.value); } }, bankAccounts.map(function (bankAccount) { return (React.createElement(FormControlLabel, { key: bankAccount.id, value: bankAccount.id, label: React.createElement(CardWrapper, null,
                    React.createElement(Card, { variant: "outlined" },
                        React.createElement(CardContent, null,
                            React.createElement(Grid, { container: true, spacing: 1 }, summaryColumns.map(function (column) { return (React.createElement(React.Fragment, null,
                                React.createElement(Grid, { item: true, xs: 6 },
                                    React.createElement(Typography, { variant: "caption" }, t("params.producerBankAccount.".concat(column)) +
                                        ':')),
                                React.createElement(Grid, { item: true, xs: 6 },
                                    React.createElement(Typography, { variant: "caption" }, bankAccount[column])))); }))))), control: React.createElement(Radio, null) })); })))));
};
export default SelectBankAccountList;
var templateObject_1;
